import { useEffect, useRef, useState } from 'react'
import type { JSX, ReactNode } from 'react'

import styles from '~publish/legacy/integrations-bar/styles.module.css'

export function ComposerToolbarFrame({
  children,
}: {
  children: ReactNode
}): JSX.Element {
  // Stuck detection: a zero-height sentinel is rendered immediately after the
  // sticky bar, riding its natural layout position. When the bar is pinned to
  // the scroll viewport bottom, the sentinel sits below the viewport (not
  // intersecting) → stuck. When the user has scrolled to the end and the bar
  // reaches its natural position, the sentinel is visible → unstuck.
  const sentinelRef = useRef<HTMLDivElement>(null)
  const [isStuck, setIsStuck] = useState(false)
  useEffect(() => {
    const sentinel = sentinelRef.current
    if (!sentinel) return
    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting),
      { threshold: [0] },
    )
    observer.observe(sentinel)
    return (): void => observer.disconnect()
  }, [])

  return (
    <>
      <div className={styles.integrationsWrapper} data-stuck={isStuck}>
        {children}
      </div>
      <div ref={sentinelRef} aria-hidden="true" />
    </>
  )
}
